import { render, staticRenderFns } from "./SalaryInsurance.vue?vue&type=template&id=748c8152&scoped=true"
import script from "./SalaryInsurance.vue?vue&type=script&lang=js"
export * from "./SalaryInsurance.vue?vue&type=script&lang=js"
import style0 from "./SalaryInsurance.vue?vue&type=style&index=0&id=748c8152&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "748c8152",
  null
  
)

export default component.exports